import Vue from 'vue'
function toFixed (num, decimals) {  
    return num.toFixed(decimals)    
}

function toSek(num){
    return num/10
}

Vue.filter('toFixed', toFixed)
Vue.filter('toSek', toSek)
Vue.filter('toCurrency', function (value) { 
    var formatter = new Intl.NumberFormat('sv-SE', {
        style: 'currency',
        currency: 'SEK',
        minimumFractionDigits: 0
    })
    return formatter.format(value)
  })
  